import Vue from 'vue';

export default {
  state: {
    fund: {},
  },
  mutations: {
    updateFundMNInvestMoneyManagement(state, { id, data }) {
      // 变更状态
      state.fund[id] = data;
    },
  },
  actions: {
    updateFundMNInvestMoneyManagement({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('FundApi.getFundMNInvestMoneyManagement', id)
          .then((json) => {
            // console.log(`zxy----updateBasicInformation---${JSON.stringify(json)}`);
            commit('updateFundMNInvestMoneyManagement', {
              id,
              data: json.Datas,
            });
            resolve(json.Datas);
          }).catch((error) => reject(error));
      });
    },
  },
  getters: {},
};
